function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @flow
import ToolTip from '@airwallex/tooltip';
import snakeCase from 'lodash.snakecase';
import React, { Component } from 'react';
import { colors } from '@airwallex/global';
import ReduxRadioGroup from './redux';
import { Label, LabelContent, RadioHolder, RadioInput, Subtitle, ToolTipContainer } from './styles';
import { Bullet } from './Bullet/Bullet';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Radio = /*#__PURE__*/function (_Component) {
  _inherits(Radio, _Component);

  var _super = _createSuper(Radio);

  function Radio() {
    var _this;

    _classCallCheck(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocusedState: false,
      isHoveredState: false
    });

    _defineProperty(_assertThisInitialized(_this), "hoverElement", function () {
      _this.setState({
        isHoveredState: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unHoverElement", function () {
      _this.setState({
        isHoveredState: false
      });
    });

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$borderCol = _this$props.borderColor,
          borderColor = _this$props$borderCol === void 0 ? colors.ultraViolet : _this$props$borderCol,
          _this$props$innerColo = _this$props.innerColor,
          innerColor = _this$props$innerColo === void 0 ? colors.ultraViolet : _this$props$innerColo,
          disabled = _this$props.disabled,
          label = _this$props.label,
          selected = _this$props.selected,
          style = _this$props.style,
          name = _this$props.name,
          value = _this$props.value,
          lastOption = _this$props.lastOption,
          _this$props$tooltip = _this$props.tooltip,
          tooltip = _this$props$tooltip === void 0 ? {} : _this$props$tooltip,
          vertical = _this$props.vertical,
          _this$props$meta = _this$props.meta,
          meta = _this$props$meta === void 0 ? {} : _this$props$meta,
          _this$props$horizonta = _this$props.horizontal,
          horizontal = _this$props$horizonta === void 0 ? false : _this$props$horizonta,
          subtitle = _this$props.subtitle,
          onClick = _this$props.onClick,
          etc = _objectWithoutProperties(_this$props, ["borderColor", "innerColor", "disabled", "label", "selected", "style", "name", "value", "lastOption", "tooltip", "vertical", "meta", "horizontal", "subtitle", "onClick"]);

      var isHoveredState = this.state.isHoveredState;
      var valueAsString = typeof value === 'string' ? value : JSON.stringify(value);
      var id = "".concat(name, "_").concat(valueAsString);
      var cursor = (!selected && !disabled).toString();
      return ___EmotionJSX(RadioHolder, {
        style: style,
        vertical: vertical,
        "data-test": snakeCase("".concat(meta.form, " ").concat(name, " ").concat(valueAsString)),
        onMouseOver: this.hoverElement,
        onMouseLeave: this.unHoverElement
      }, ___EmotionJSX(RadioInput, _extends({}, etc, {
        id: id,
        type: "radio",
        name: name,
        value: value,
        onChange: onClick,
        checked: selected,
        disabled: disabled
      })), ___EmotionJSX(Label, {
        htmlFor: id,
        horizontal: horizontal
      }, ___EmotionJSX(LabelContent, {
        cursor: cursor,
        disabled: disabled,
        lastOption: lastOption,
        vertical: vertical,
        horizontal: horizontal
      }, ___EmotionJSX(Bullet, {
        disabled: disabled,
        borderColor: borderColor,
        innerColor: innerColor,
        isFilled: selected,
        hovered: isHoveredState
      }), label, Object.prototype.hasOwnProperty.call(tooltip, 'data') && ___EmotionJSX(ToolTipContainer, {
        horizontal: horizontal
      }, ___EmotionJSX(ToolTip, {
        data: tooltip.data,
        title: tooltip.title
      }))), horizontal && subtitle && ___EmotionJSX(Subtitle, null, subtitle)));
    }
  }]);

  return Radio;
}(Component);

export { Radio as default, ReduxRadioGroup, Bullet };